import script from "./UIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIcon.vue?vue&type=script&setup=true&lang=ts"

import "./UIcon.vue?vue&type=style&index=0&id=0aa64b99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa64b99"]])

export default __exports__